import { FTUXType } from "Player/PlayerProperty/Progress/FTUXType";
import { CardModifierType } from "Prototype/Level/Card/CardModifierType";
import { CardType } from "Prototype/Level/Card/CardType";
import { levelContainsCardWithModifier, levelContainsCardOfType } from "State/Card/CardStateHelper";
import { FTUXStateHelper } from "State/Game/FTUX/FTUXStateHelper";
import { IFTUXLevelTaskData } from "State/Game/FTUX/IFTUXLevelTaskData";
import { IGameState } from "State/Game/IGameState";
import { isGoldLevel } from "State/Level/LevelStateHelper";
import { LevelTask } from "State/Level/LevelTask";
import { BoosterType } from 'State/Card/BoosterType';


export const FTUXAutoPlayLevelCap: number = 3;
export const FTUXFreeLevels: number = 3;

export const FTUX_LEVEL_TASKS: IFTUXLevelTaskData[] = [
    {
        priority: 0,
        type: FTUXType.GOLD_CARD,
        taskType: LevelTask.FTUX_GOLD,
        condition: (state: IGameState) => {
            return (
                isGoldLevel(state.levelState) && !FTUXStateHelper.isFtuxCompleted(state.playerState, FTUXType.GOLD_CARD)
            );
        },
    },
    {
        priority: 1,
        type: FTUXType.ICE_CARD,
        taskType: LevelTask.FTUX_ICE,
        condition: (state: IGameState) => {
            return (
                levelContainsCardWithModifier(state.levelState.cardsState, CardModifierType.ice) &&
                !FTUXStateHelper.isFtuxCompleted(state.playerState, FTUXType.ICE_CARD)
            );
        },
    },
    {
        priority: 1,
        type: FTUXType.LOCK_CARD,
        taskType: LevelTask.FTUX_LOCK,
        condition: (state: IGameState) => {
            return (
                levelContainsCardOfType(state.levelState.cardsState, CardType.lock) &&
                !FTUXStateHelper.isFtuxCompleted(state.playerState, FTUXType.LOCK_CARD)
            );
        },
    },
    {
        priority: 1,
        type: FTUXType.TOMATO_BOMB,
        taskType: LevelTask.FTUX_HAZARD_BOMB,
        condition: (state: IGameState) => {
            return (
                levelContainsCardWithModifier(state.levelState.cardsState, CardModifierType.bomb) &&
                !FTUXStateHelper.isFtuxCompleted(state.playerState, FTUXType.TOMATO_BOMB)
            );
        },
    },
    {
        priority: 1,
        type: FTUXType.SCYTHE,
        taskType: LevelTask.FTUX_SCYTHE,
        condition: (state: IGameState) => {
            return (
                levelContainsCardOfType(state.levelState.cardsState, CardType.zap) &&
                !FTUXStateHelper.isFtuxCompleted(state.playerState, FTUXType.SCYTHE)
            );
        },
    },
    {
        priority: 1,
        type: FTUXType.BOMB_CARD,
        taskType: LevelTask.FTUX_WATERMELON,
        condition: (state: IGameState) => {
            return (
                !FTUXStateHelper.isFtuxCompleted(state.playerState, FTUXType.BOMB_CARD) &&
                levelContainsCardOfType(state.levelState.cardsState, CardType.boom)
            );
        },
    },
    {
        priority: 1,
        type: FTUXType.RISE_LOWER_CARDS,
        taskType: LevelTask.FTUX_RISE_LOWER,
        condition: (state: IGameState) => {
            return (
                !FTUXStateHelper.isFtuxCompleted(state.playerState, FTUXType.BOMB_CARD) &&
                (levelContainsCardWithModifier(state.levelState.cardsState, CardModifierType.rising) ||
                    levelContainsCardWithModifier(state.levelState.cardsState, CardModifierType.lowering))
            );
        },
    },
    {
        priority: 1,
        type: FTUXType.PLUS_THREE_CARD,
        taskType: LevelTask.FTUX_HARVEST_FESTIVAL,
        condition: (state: IGameState) => {
            return (
                !FTUXStateHelper.isFtuxCompleted(state.playerState, FTUXType.PLUS_THREE_CARD) &&
                levelContainsCardOfType(state.levelState.cardsState, CardType.plus_three)
            );
        },
    },
    {
        priority: 1,
        type: FTUXType.STONE_CARD,
        taskType: LevelTask.FTUX_PICKAXE,
        condition: (state: IGameState) => {
            return (
                !FTUXStateHelper.isFtuxCompleted(state.playerState, FTUXType.STONE_CARD) &&
                levelContainsCardOfType(state.levelState.cardsState, CardType.rock)
            );
        },
    },
    {
        priority: 1,
        type: FTUXType.ROPE_CARD,
        taskType: LevelTask.FTUX_ROPE,
        condition: (state: IGameState) => {
            return (
                !FTUXStateHelper.isFtuxCompleted(state.playerState, FTUXType.ROPE_CARD) &&
                levelContainsCardWithModifier(state.levelState.cardsState, CardModifierType.rope)
            );
        },
    },
    {
        priority: 1,
        type: FTUXType.TORNADO_CARD,
        taskType: LevelTask.FTUX_TORNADO,
        condition: (state: IGameState) => {
            return (
                !FTUXStateHelper.isFtuxCompleted(state.playerState, FTUXType.TORNADO_CARD) &&
                levelContainsCardOfType(state.levelState.cardsState, CardType.tornado)
            );
        },
    },
    {
        priority: 1,
        type: FTUXType.FOG_CARD,
        taskType: LevelTask.FTUX_FOG,
        condition: (state: IGameState) => {
            return (
                !FTUXStateHelper.isFtuxCompleted(state.playerState, FTUXType.FOG_CARD) &&
                levelContainsCardWithModifier(state.levelState.cardsState, CardModifierType.fog)
            );
        },
    },
    {
        priority: 1,
        type: FTUXType.CONNECTED_CARDS,
        taskType: LevelTask.FTUX_CONNECTED_CARDS,
        condition: (state: IGameState) => {
            return (
                !FTUXStateHelper.isFtuxCompleted(
                    state.playerState,
                    FTUXType.CONNECTED_CARDS
                ) &&
                levelContainsCardWithModifier(
                    state.levelState.cardsState,
                    CardModifierType.connected
                )
            );
        },
    },
    {
        priority: 1,
        type: FTUXType.JOKER,
        taskType: LevelTask.FTUX_BOOSTER_JOKER,
        condition: (state: IGameState) => {
            return (
                !FTUXStateHelper.isFtuxCompleted(state.playerState, FTUXType.JOKER) &&
                state.playerState.inventory[BoosterType.JOKER] > 0 &&
                state.levelState.levelNumber === 6
            );
        },
    },
    {
        priority: 1,
        type: FTUXType.TNT_MODIFIER,
        taskType: LevelTask.FTUX_TNT_MODIFIER,
        condition: (state: IGameState) => {
            return (
                levelContainsCardWithModifier(state.levelState.cardsState, CardModifierType.tnt) &&
                !FTUXStateHelper.isFtuxCompleted(state.playerState, FTUXType.TNT_MODIFIER)
            );
        },
    },
];
